<template>
  <div class="panel-group">
    <div class="panel-wrapper">
      <div class="panel-wrapper-header">
        <div class="panel-wrapper-header-tabs">
          <widgetTabs v-model="activeTab" :tabs="[
            {
              title: 'Drafts',
              value: 'drafts',
              icon: {
                inactive: require('@/assets/icons/draft-gray.svg'),
                active: require('@/assets/icons/draft-green.svg')
              }
            },
            {
              title: 'Sent Emails',
              value: 'sentEmails',
              icon: {
                inactive: require('@/assets/icons/sent-email-gray.svg'),
                active: require('@/assets/icons/sent-email-green.svg')
              }
            },
            {
              title: 'Signatures',
              value: 'signatures',
              icon: {
                inactive: require('@/assets/icons/signature-gray.svg'),
                active: require('@/assets/icons/signature-green.svg')
              }
            },
          ]" @change="switchTab"></widgetTabs>
        </div>
      </div>
      <div class="panel-wrapper-heading">
        <div class="panel-heading-title">
          All Signatures
        </div>
        <div class="panel-headeing-options">
          <widgetButton @click="AddSignature()" class="btn-transparent-primary outline">
            Add New +
          </widgetButton>
        </div>
      </div>
      <div class="panel-wrapper-body">
        <div class="panel-wrapper-body-container">
          <div class="signature-item" v-for="(item, index) in signatures" :key="index" @click="selectItem(item)" :class="{
            active:
              selected_item_details && item.id === selected_item_details.id,
          }">
            <div class="signature-item-header">
              <div class="signature-item-header-title">{{ item.name }}</div>
            </div>
            <div class="signature-item-body">
              <div class="signature-footer">
                <div class="signature-created-date">
                  {{ moment(item.created_at).format("MMM DD,YYYY HH:mm A") }}
                </div>
                <span class="default-status" v-if="item.default">Default</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="signature-preview">
      <!-- Tab content details for email -->
      <div class="tab-content-details" v-if="selected_item_details">
        <div class="tab-content-details-header">
          <div class="tab-content-details-header-left-panel">
            <div class="email-user-profile">
              <widgetProfile :title="selected_item_details.name" :subtitle="''" :file_name="null"
                :path="$fullUrl('images/profiles/')" :size="40" :text_size="14"></widgetProfile>
            </div>
          </div>
          <div class="tab-content-details-options row">
            <widgetButton v-if="!selected_item_details.default" @click="makeSignatureDefault(selected_item_details)"
              class="btn-transparent-secondary">
              Make default
            </widgetButton>
            <div class="h-spacer"></div>
            <dropdown-menu>
              <ul>
                <li>
                  <a @click.prevent="
                    updateSignatureEmail(selected_item_details)
                    ">Edit Signature</a>
                </li>
                <li>
                  <app-dialog title="Delete Email" ask="Are you sure you want to delete this signature?"
                    yesText="Delete" noText="Cancel" @onComfirm="deleteSignatureEmail(selected_item_details)">
                    <a>Delete Signature</a>
                  </app-dialog>
                </li>
              </ul>
            </dropdown-menu>
          </div>
        </div>

        <div class="tab-content-details-body" v-html="selected_item_details.message"></div>
      </div>

      <!-- When no item selected -->
      <div class="widget-notfound" v-if="!selected_item_details">
        <widgetNotFoundWidget title="No signature selected"
          content="Select signature from the list to view information here" align="center">
          <img class="widget-img" src="@/assets/icons/select-item.svg" />
        </widgetNotFoundWidget>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "",
  components: {},
  props: {
    phase: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      activeTab: 3,
      selected_item_details: null,
      signatures: [],
      loading_page_data: false,
    };
  },
  mounted() {
    let vm = this;
    eventBus.$on("signatureReflesh", () => {
      vm.getEmailSignature();
    });
    vm.getEmailSignature();
  },
  computed: {},
  watch: {},
  methods: {
    switchTab(tab) {
      let vm = this;
      if (tab.value == "drafts") {
        vm.activeTab = 1;
      } else if (tab.value == "outbox") {
        vm.activeTab = 2;
      } else if (tab.value == "signatures") {
        vm.activeTab = 3;
      }
      vm.$emit("switchTab", vm.activeTab);
    },
    selectItem(item) {
      let vm = this;
      vm.selected_item_details = item;
    },
    updateSignatureEmail(item) {
      let vm = this;
      vm.$emit("updateSignature", item);
    },
    AddSignature() {
      let vm = this;
      vm.$emit("addSignature");
    },
    makeSignatureDefault(item) {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_SIGNATURE_MARK_AS_DEFAULT", {
          id: item.id,
        })
        .then((responce) => {
          item.default = 1;
          vm.getEmailSignature();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Signature is now marked as default",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          item.loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something went wrong",
            type: "warn",
            duration: 3000,
          });
        });
    },
    deleteSignatureEmail(item) {
      let vm = this;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_SIGNATURE_DELETE", { id: item.id })
        .then((responce) => {
          vm.selected_item_details = null;
          vm.getEmailSignature();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Signature is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          item.loading = false;
          vm.$notify({
            group: "status",
            title: "Warning",
            text: "Something wrong while deleting signature",
            type: "warn",
            duration: 3000,
          });
        });
    },
    getEmailSignature() {
      let vm = this;
      vm.loading_page_data = true;
      vm.$store
        .dispatch("PROCESSMESSAGE_EMAIL_GET_SIGNATURE")
        .then((responce) => {
          vm.loading_page_data = false;
          vm.signatures = responce.data.map((item) => {
            eventBus.$set(item, "editing", false);
            eventBus.$set(item, "loading", false);
            return item;
          });
        })
        .catch((error) => {
          vm.loading_page_data = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.panel-group {
  width: calc(100% - 330px);
  display: flex;
  height: 100%;

  .panel-wrapper {
    width: 320px;
    height: 100%;

    .panel-wrapper-header {
      height: 50px;
      background: #ffffff;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;

      .panel-wrapper-header-tabs {
        height: 50px;
        display: flex;
        align-items: center;
        padding: 0px 5px;
        width: 100%;
      }
    }

    .panel-wrapper-heading {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 35px;
      background: #ffffff;
      padding: 0px 5px;

      .panel-heading-title {
        font-family: 'Nunito';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        color: #000000;
      }
    }

    .panel-wrapper-body {
      height: calc(100% - 90px);
      overflow-y: auto;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;

      .panel-wrapper-body-container {
        background: #ffffff;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        padding-bottom: 5px;

        .signature-item {
          padding: 5px 5px;
          transition: 0.3s ease-in-out;
          cursor: pointer;

          &:hover {
            background: #f4f4f4;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
            transition: 0.1s ease-in-out;
          }

          &.active {
            background: #f4f4f4;
            transition: 0.1s ease-in-out;
          }

          .signature-item-header {
            display: flex;
            flex-direction: column;
            margin-bottom: 7px;

            .signature-item-header-profile {
              margin-right: 5px;
              margin-bottom: 10px;
            }

            .signature-item-header-title {
              font-family: "Nunito";
              font-style: normal;
              font-weight: 700;
              font-size: 12px;
              line-height: 15px;
              color: #1c1c1c;
            }
          }

          .signature-item-body {
            .signature-footer {
              display: flex;
              align-items: center;
              justify-content: space-between;

              .signature-created-date {
                color: #7d92a1;
                font-size: 11px;
              }

              .default-status {
                color: #0884af;
              }
            }
          }
        }
      }
    }
  }

  .signature-preview {
    width: calc(100% - 320px);
    height: 100%;
    border-radius: 7px;
    margin-left: 5px;

    .tab-content-details {
      width: 100%;
      height: max-content;
      border-radius: 5px;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      padding: 0px 15px;
      padding-bottom: 80px;

      .tab-content-details-header {
        height: 70px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .tab-content-details-header-left-panel {
          .email-user-profile {
            margin-bottom: 10px;
          }
        }

        .tab-content-details-options {
          display: flex;
          align-items: center;
        }
      }

      .email-subject {
        font-family: "Nunito";
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        color: #1c1c1c;
        margin-bottom: 10px;
      }

      .tab-content-details-body {
        padding: 15px;
        background: #fafafa;
        border-radius: 10px;
      }
    }

    .widget-notfound {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      background: #ffffff;
      border-radius: 5px;
    }
  }
}
</style>